import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import dateFormat from 'date-fns/format';
import { combineLatest, take } from 'rxjs';

import { BrandSelectors } from '@amfam/shared/utility/brand';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { ValidationService } from '@amfam/ui-kit';

import { AutoPaySetupSelectors, AutoPayUtilService } from '../../..';

@Component({
  selector: 'ds-hs-auto-pay-review-wrapper',
  templateUrl: './hs-auto-pay-review-wrapper.component.html',
  styleUrls: ['./hs-auto-pay-review-wrapper.component.scss'],
  standalone: false
})
export class HsAutoPayReviewWrapperComponent implements OnInit {
  submitted = false;
  recurringReviewForm = this.buildForm();
  reviewSubheading: string;
  alertMessage: string;
  secondaryButtonName: string;
  primaryButtonName: string;
  riskDescription: string;
  authorizeText: string;
  amountSubheading: string;
  // The below details should be pulled from store once billingAPI & iframe are integrated.
  data = {
    selectedPaymentAmount: 23.99,
    frequency: 'Installments',
    cardDetails: 'Mastercard 1234'
  };

  constructor(
    private store: Store,
    private copyService: CopyService,
    private formBuilder: FormBuilder,
    private autoPayUtil: AutoPayUtilService
  ) {}

  get valid(): boolean {
    return this.recurringReviewForm.valid;
  }

  ngOnInit(): void {
    this.store
      .select(AutoPaySetupSelectors.selectActiveSetup)
      .pipe(take(1))
      .subscribe(setup => {
        this.riskDescription = setup.billAccount.riskDescription;
      });
    this.store
      .select(BrandSelectors.selectECUnderWrittingCustServicePhoneNum)
      .pipe(take(1))
      .subscribe(custServPhoneNum => {
        this.authorizeText = this.copyService.getCopy('billing.recurring.authorizeText', {
          partnerCustServPhoneNum: custServPhoneNum
        });
      });

    // The date should be pulled from store once billingAPI is integrated.
    const dueDate: Date = new Date();
    this.reviewSubheading =
      this.copyService.getCopy('billing.phoenixPayment.reviewSubheading') +
      dateFormat(dueDate, 'MMM DD, YYYY');
    this.alertMessage = this.copyService.getCopy('billing.phoenixPayment.alertMessage');
    this.secondaryButtonName = this.copyService.getCopy('shared.goBackBtn');
    this.primaryButtonName = this.copyService.getCopy('shared.continueBtn');
    this.amountSubheading = this.copyService.getCopy('billing.recurring.recurringSubheading');
  }

  submit() {
    this.submitted = true;
    if (this.valid) {
      combineLatest([
        this.store.select(AutoPaySetupSelectors.selectAllAutoPaySetups),
        this.store.select(AutoPaySetupSelectors.selectContext)
      ])
        .pipe(take(1))
        .subscribe(([setups, context]) => {
          this.autoPayUtil.saveAutoPay(context, setups);
        });
    }
  }

  goBackOneStep() {
    this.store
      .select(AutoPaySetupSelectors.selectEntryPoint)
      .pipe(take(1))
      .subscribe(entryPoint => {
        this.store.dispatch(
          fromRouterActions.Go({
            path: [entryPoint]
          })
        );
      });
  }

  private buildForm() {
    return this.formBuilder.group({
      electronicSignature: [
        '',
        [
          ValidationService.validateWithKey(Validators.required, 'recurring.esignature.required'),
          ValidationService.customerFullNameValidator,
          ValidationService.validateWithKey(
            Validators.maxLength(65),
            'recurring.esignature.maxLength'
          )
        ]
      ]
    });
  }
}
